(function () {
  function buildModalSwiper(modal, initialSlide) {
    if (modal._swiperInstance) return; // already built, don't double-init

    if (typeof Swiper === 'undefined') {
      console.error('Swiper is missing! Check dependency load order.');
      return;
    }

    const swiperEl = modal.querySelector('.product-modal-swiper');
    const thumbsEl = modal.querySelector('.product-modal-thumbs');

    if (!swiperEl || !swiperEl.querySelector('.swiper-wrapper')) return;

    const nextEl = modal.querySelector('.product-modal-button-next');
    const prevEl = modal.querySelector('.product-modal-button-prev');

    const thumbSwiper = new Swiper(thumbsEl, {
      spaceBetween: 16,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      initialSlide: initialSlide || 0
    });

    const mainSwiper = new Swiper(swiperEl, {
      autoHeight: true,
      allowTouchMove: true,
      slidesPerView: 1,
      spaceBetween: 0,
      watchOverflow: true,
      initialSlide: initialSlide || 0,
      navigation: {
        nextEl,
        prevEl
      },
      thumbs: {
        swiper: thumbSwiper
      }
    });

    modal._swiperInstance = mainSwiper;
    modal._thumbSwiperInstance = thumbSwiper;
  }

  function targetMediaIdFromOpener(modal) {
    // ModalDialog.show(opener) sets modal.openedBy.
    // This gives us the exact gallery item that opened the modal.
    const opener = modal.openedBy;
    const raw = opener?.getAttribute('data-media-id');

    if (!raw) return null;

    // Gallery media IDs may be prefixed with the section ID:
    // section-id-media-id
    //
    // Modal slides use only:
    // media-id
    const match = raw.match(/(\d+)$/);

    return match ? match[1] : raw;
  }

  function findModalIndexForMedia(modal, mediaId) {
    if (!mediaId) return -1;

    const slides = Array.from(
      modal.querySelectorAll('.product-modal-swiper .swiper-slide')
    );

    return slides.findIndex(
      (slide) =>
        slide.querySelector('[data-media-id]')?.dataset.mediaId === mediaId
    );
  }

  function handleModalOpen(modal) {
    const mediaId = targetMediaIdFromOpener(modal);
    const isFirstBuild = !modal._swiperInstance;

    // Resolve the clicked media before creating Swiper.
    const targetIndex = findModalIndexForMedia(modal, mediaId);

    if (isFirstBuild) {
      buildModalSwiper(
        modal,
        targetIndex > -1 ? targetIndex : 0
      );

      requestAnimationFrame(() => {
        modal._swiperInstance?.update();
        modal._swiperInstance?.updateAutoHeight(0);
        modal._thumbSwiperInstance?.update();
      });

      return;
    }

    // Swiper already exists, so it is safe to move to the
    // newly clicked media.
    requestAnimationFrame(() => {
      modal._swiperInstance.update();
      modal._swiperInstance.updateAutoHeight(0);
      modal._thumbSwiperInstance?.update();

      if (targetIndex > -1) {
        modal._swiperInstance.slideTo(targetIndex, 0);
      }
    });
  }

  function observeModal(modal) {
    if (modal._openObserver) return;

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.attributeName === 'open' &&
          modal.hasAttribute('open')
        ) {
          handleModalOpen(modal);
        }
      }
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['open']
    });

    modal._openObserver = observer;
  }

  function init() {
    const modal = document.querySelector('product-modal');

    if (!modal) return;

    observeModal(modal);
  }

  /**
   * Product modal custom element
   */
  class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        const isInteractiveArea = event.target.closest(
          'img, deferred-media, product-model, .product-modal-button-next, .product-modal-button-prev, .product-modal-thumbs, .modal-close-button'
        );

        if (!isInteractiveArea) {
          this.hide();
        }
      });
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      // IMPORTANT:
      // Let ModalDialog.show() set openedBy before our
      // MutationObserver reacts to the modal opening.
      super.show(opener);
    }
  }

  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }

  // Initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-attach observer after Shopify Theme Editor section reloads.
  document.addEventListener('shopify:section:load', init);
})();
